import { Component, Input, OnChanges } from '@angular/core';
import { setOccupationChartDataset } from 'src/app/helpers/chart-helper';
import { toExcelFormat } from 'src/app/helpers/format-position';

@Component({
  selector: 'app-pigeonhole-row-column-details',
  templateUrl: './pigeonhole-row-column-details.component.html',
  styleUrls: ['./pigeonhole-row-column-details.component.scss']
})
export class PigeonholeRowColumnDetailsComponent implements OnChanges {
  @Input() occupationList = [];
  @Input() coords = '';
  @Input() pigeonholes = [];
  tableData = [];
  showEmptyMsg = false;
  datasets = [{
    data: [0, 0],
    backgroundColor: ['#92B531', '#E8EBEF']
  }];
  chartLabels = ['Posições Ocupadas', 'Posições Livres'];

  constructor() { }

  ngOnChanges(): void {
    this.showEmptyMsg = true;
    
    if (this.occupationList) {
      this.showEmptyMsg = false;
      this.datasets[0].data = setOccupationChartDataset(this.occupationList);
    }
    
    this.setTableData();
  }

  setTableData() {
    if (!this.pigeonholes?.length) return;
    this.pigeonholes.map(pos => {
      this.tableData.push({
        qrCode: pos.qrCode,
        type: pos.type,
        alias: pos?.alias,
        groupType: pos?.type,
        coords: `${toExcelFormat(pos.column, pos.row)}`
      });
    });
  }
}
